import { ClientConfigInfo } from './configs/configCommons'
import { oxxoConfigs } from './configs/oxxo'
import { mitsubishiConfigs } from './configs/mitsubishi'
import { haConfigs } from './configs/ha'
import { gnpConfigs } from './configs/gnp'
import { suzukiConfigs } from './configs/suzuki'
import { caffenioConfigs } from './configs/caffenio'
import { bydConfigs } from './configs/byd'
import { localConfigs } from './configs/local'
import { iamsaConfigs } from './configs/iamsa'
import { profuturoConfigs } from './configs/profuturo'
import { jacConfigs } from './configs/jac'
import { benavidesConfigs } from './configs/benavides'

interface ClientConfigList {
    [client: string]: ClientConfigInfo
}

const CLIENTS_CONFIGS: ClientConfigList = {
    oxxo: oxxoConfigs,
    mitsubishi: mitsubishiConfigs,
    ha: haConfigs,
    gnp: gnpConfigs,
    suzuki: suzukiConfigs,
    caffenio: caffenioConfigs,
    byd: bydConfigs,
    iamsa: iamsaConfigs,
    profuturo: profuturoConfigs,
    jac: jacConfigs,
    benavides: benavidesConfigs,
    local: localConfigs
}

export const getClientConfigs = (clientName: string): ClientConfigInfo => {
    //const clientName = getClientName()
    return CLIENTS_CONFIGS[clientName]
}

